export default {
    "emailAddress": "s@gmail.com",
    "undeliverable": false,
    "lastUpdateDateTime": "2023-02-28T19:10:56.702+00:00"
}